import { motion } from "framer-motion";

const brands = ["NETFLIX", "PLAYSTATION"];

export const ComingSoon = () => (
  <section className="mx-auto max-w-6xl px-5 pb-20" data-testid="coming-soon-section">
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6 }}
      className="rounded-3xl border border-white/[0.07] bg-[#1a1633]/60 p-8 sm:p-10"
    >
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-violet-300">Coming soon</p>
      <h2 className="mt-3 font-display text-2xl font-semibold text-white sm:text-3xl">More brands are on the way</h2>
      <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4 sm:gap-x-12">
        {brands.map((b, i) => (
          <motion.span
            key={b}
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.5, delay: i * 0.07 }}
            className="flex items-center gap-8 font-display text-lg font-semibold tracking-tight text-zinc-500 transition-colors hover:text-zinc-300 sm:text-xl"
          >
            {b}
            {i < brands.length - 1 && <span className="h-1.5 w-1.5 rounded-full bg-violet-500/70" />}
          </motion.span>
        ))}
      </div>
    </motion.div>
  </section>
);
